import styles from './A_CopyLinkButton.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface A_CopyLinkButtonProps {
  getLinkToCopy?: () => Promise<string>;
}

export default function A_CopyLinkButton({
  getLinkToCopy,
}: A_CopyLinkButtonProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  const handleCopyLink = async () => {
    const link = getLinkToCopy ? await getLinkToCopy() : window.location.href;
    await navigator.clipboard.writeText(link);
  };

  return (
    <button
      className={cn(styles.wrapper, 'text-p-4')}
      onClick={() => {
        void handleCopyLink();
      }}
    >
      <Q_Icon.CopyIcon width={24} height={24} fill='none' />
      {t('inviteCoauthors.copyLink')}
    </button>
  );
}
